import type { EventMap, IdentifyFn, ResetFn, TrackFn } from "./types";

let initialized = false;

export async function initAnalytics(token: string): Promise<void> {
  if (initialized || typeof window === "undefined") {
    return;
  }
  const mixpanel = (await import("mixpanel-browser")).default;
  mixpanel.init(token, {
    debug: process.env.NODE_ENV === "development",
    track_pageview: false, // manual tracking for Remix SPA navigation
    persistence: "localStorage",
  });
  initialized = true;
}

export function createTrack<TEvents extends EventMap>(): TrackFn<TEvents> {
  return (event, properties) => {
    if (typeof window === "undefined" || !initialized) {
      return;
    }
    try {
      import("mixpanel-browser").then(({ default: mp }) => mp.track(event, properties)).catch(() => {});
    } catch {
      /* tracking never throws */
    }
  };
}

export const identify: IdentifyFn = (userId, traits) => {
  if (typeof window === "undefined" || !initialized) {
    return;
  }
  try {
    import("mixpanel-browser")
      .then(({ default: mp }) => {
        mp.identify(userId);
        if (traits) mp.people.set(traits);
      })
      .catch(() => {});
  } catch {
    /* identification never throws */
  }
};

export const reset: ResetFn = () => {
  if (typeof window === "undefined" || !initialized) {
    return;
  }
  import("mixpanel-browser").then(({ default: mp }) => mp.reset()).catch(() => {});
};
